module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAApUlEQVRYR+2W0Q2DMAxEz4iqK+SPbAIroQ5QGACxEmwS/rJCBcJVK/GBRD4tB8kZwHd6dk5HUH6krA8zkBeBz+A6InpL3gUz989X7A6NEwF1A+vomn1HI0mgKDA92jhdEpAUTs3O6wiNgBHg0fmNUUmSKAkLtTHkGUTqSfhfAeBFVwCE5AokhS0JjcA9CPwKCYBa+DfMyUKiHkTqBoTRX463SmYEvqWNSSHVwxkAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 01ru
// module chunks = 7